import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './index.css';
import App from './App';
import store from './store/store';

// Monitor WebSocket connection for HMR (Hot Module Replacement)
if (process.env.NODE_ENV === 'development') {
  const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
  const hostname = window.location.hostname;
  const port = window.location.port || (window.location.protocol === 'https:' ? '443' : '80');
  const wsUrl = `${protocol}//${hostname}:${port}/ws`;
  
  console.log('%c[WEBSOCKET] Monitoring HMR WebSocket connection', 'color: purple; font-weight: bold; font-size: 14px;');
  console.log('[WEBSOCKET] Attempting to connect to:', wsUrl);
  
  try {
    const ws = new WebSocket(wsUrl);
    
    ws.onopen = () => {
      console.log('%c[WEBSOCKET] ✅ CONNECTED SUCCESSFULLY', 'color: green; font-weight: bold; font-size: 14px;');
      console.log('[WEBSOCKET] Connection URL:', wsUrl);
      console.log('[WEBSOCKET] ReadyState:', ws.readyState, '(OPEN)');
    };
    
    ws.onclose = (event) => {
      if (event.wasClean) {
        console.log('%c[WEBSOCKET] 🔌 Disconnected (clean)', 'color: orange; font-weight: bold;');
        console.log('[WEBSOCKET] Code:', event.code, 'Reason:', event.reason);
      } else {
        console.error('%c[WEBSOCKET] ❌ Connection failed or closed unexpectedly', 'color: red; font-weight: bold; font-size: 14px;');
        console.error('[WEBSOCKET] Code:', event.code, 'Reason:', event.reason || 'No reason provided');
        console.error('[WEBSOCKET] This is normal if HMR is disabled or server is not running');
      }
    };
    
    ws.onerror = (error) => {
      console.error('%c[WEBSOCKET] ❌ Connection error', 'color: red; font-weight: bold; font-size: 14px;');
      console.error('[WEBSOCKET] Error details:', error);
      console.error('[WEBSOCKET] This is normal if HMR is disabled');
    };
    
    ws.onmessage = (event) => {
      try {
        const data = JSON.parse(event.data);
        if (data.type === 'hash' || data.type === 'still-ok' || data.type === 'ok') {
          console.log('%c[WEBSOCKET] 📨 HMR message received', 'color: blue; font-weight: bold;');
          console.log('[WEBSOCKET] Message type:', data.type);
        }
      } catch (e) {
        // Not JSON, ignore
      }
    };
    
    // Check connection status periodically
    const checkInterval = setInterval(() => {
      if (ws.readyState === WebSocket.OPEN) {
        console.log('[WEBSOCKET] Status: ✅ Connected');
      } else if (ws.readyState === WebSocket.CONNECTING) {
        console.log('[WEBSOCKET] Status: 🔄 Connecting...');
      } else if (ws.readyState === WebSocket.CLOSING) {
        console.log('[WEBSOCKET] Status: 🔌 Closing...');
      } else if (ws.readyState === WebSocket.CLOSED) {
        console.log('[WEBSOCKET] Status: ❌ Closed');
        clearInterval(checkInterval);
      }
    }, 5000); // Check every 5 seconds
    
    // Cleanup on page unload
    window.addEventListener('beforeunload', () => {
      clearInterval(checkInterval);
      if (ws.readyState === WebSocket.OPEN || ws.readyState === WebSocket.CONNECTING) {
        ws.close();
      }
    });
  } catch (error) {
    console.error('%c[WEBSOCKET] ❌ Failed to create WebSocket', 'color: red; font-weight: bold;');
    console.error('[WEBSOCKET] Error:', error.message);
  }
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <App />
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
);


